import axios from "axios"

// let port = window.location.port === "3000" ? 4001 : window.location.port
const instance = axios.create({
  baseURL: process.env.REACT_APP_INTERACTIONS_API_ENDPOINT,
})

export const createNewInteractionsProject = async (user, token, graphicsProjectId) => {
  try {
    return await instance
      .post(`/?user=${user}&token=${token}&graphicsProjectId=${graphicsProjectId}`)
      .then(function (response) {
        return response
      })
      .catch(function (error) {
        console.log(error)
      })
  } catch (error) {
    console.error(error)
  }
}

export const updateInteractionsProject = async (user, token, interactionProjectId, update) => {
  try {
    return await instance
      .patch(`${interactionProjectId}/?user=${user}&token=${token}`, { update })
      .then(function (response) {
        return response
      })
      .catch(function (error) {
        console.log(error)
      })
  } catch (error) {
    console.error(error)
  }
}

export const addNewQuestion = async (interactionProjectId, user, token, type) => {
  try {
    return await instance
      .post(`${interactionProjectId}/question?user=${user}&token=${token}&type=${type}`)
      .then(function (response) {
        return response
      })
      .catch(function (error) {
        console.log(error)
      })
  } catch (error) {
    console.error(error)
  }
}

export const updateQuestion = async (user, token, interactionProjectId, questionId, update) => {
  try {
    return await instance
      .patch(`${interactionProjectId}/question/${questionId}?user=${user}&token=${token}`, { update })
      .then(function (response) {
        return response
      })
      .catch(function (error) {
        console.log(error)
      })
  } catch (error) {
    console.error(error)
  }
}

export const deleteQuestion = async (user, token, interactionProjectId, questionId) => {
  try {
    return await instance
      .delete(`${interactionProjectId}/question/${questionId}?user=${user}&token=${token}`)
      .then(function (response) {
        return response
      })
      .catch(function (error) {
        console.log(error)
      })
  } catch (error) {
    console.error(error)
  }
}

// CODE

export const generateCode = async (user, token, interactionProjectId) => {
  try {
    return await instance
      .post(`${interactionProjectId}/code?user=${user}&token=${token}`)
      .then(function (response) {
        return response
      })
      .catch(function (error) {
        console.log(error)
      })
  } catch (error) {
    console.error(error)
  }
}